import { motion } from "framer-motion";
import CustomLists from "@/components/elements/CustomLists/CustomLists";
import ListWithDescription from "@/components/elements/CustomLists/ListWithDescription";
import ImageWithContentLeft from "@/components/elements/ImageWithContent/ImageWithContentLeft";
import Paragraph from "@/components/elements/Paragraph/Paragraph";
import TitleBar from "@/components/elements/TitleBar/TitleBar";
import TitleWithContent from "@/components/elements/TitleWithContent/TitleWithContent";
import r1 from "@/assets/images/services/roofwaterproofing.png"

const fadeInUp = {
  initial: { opacity: 0, y: 50 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.8, ease: "easeOut" },
  viewport: { once: false, amount: 0.2 },
};

const RoofWaterproofing = () => {
  return (
    <>
      <div className="pb-0 px-4  2xl:px-40 xl:px-40 md:px-[3rem] my-[5rem]">
        <TitleBar title="Roof Waterproofing" />
        
        <motion.div {...fadeInUp}>
          <ImageWithContentLeft alt="Roof Waterproofing"
            title="Description"
            imageUrl={r1}
            content="Roof waterproofing is the process of protecting a building's roof from water damage by applying materials that prevent water from penetrating the roof surface. Various waterproofing materials, such as asphalt coatings, liquid-applied membranes, and pre-formed sheet membranes, can be applied to existing or new structures, creating a barrier that prevents water from seeping into the building."
          />
        </motion.div>

        <motion.div {...fadeInUp}>
          <TitleWithContent title="Why Roof Waterproofing is Important">
            <CustomLists
              layout="stacked"
              items={[
                [
                  "Roofs of your establishments face harsh weather conditions, which can cause cracks, leading to water leakage.",
                  "Water seeps through these cracks, damaging the interior and weakening the structure."
                ],
                [
                  "Concrete roof waterproofing is essential to prevent these issues and protect your building."
                ]
              ]}
            />
          </TitleWithContent>
        </motion.div>

        <motion.div {...fadeInUp}>
          <TitleWithContent title="Advantages of Roof Waterproofing">
            <CustomLists
              items={[
                [
                  "Improves Structure Durability",
                  "Prevents moisture buildup, mold, and mildew damage.",
                  "Extends the lifespan of interior finishes."
                ],
                [
                  "Reduces Repair Costs",
                  "Prevents leaks and water damage, lowering long-term maintenance expenses.",
                  "A one-time solution that avoids frequent repair needs."
                ]
              ]}
            />
          </TitleWithContent>
        </motion.div>

        <motion.div {...fadeInUp}>
          <TitleWithContent title="Types of Roof Waterproofing Systems">
            <Paragraph
              content="We offer various types of roof waterproofing systems designed to protect your structure from water damage. Here's a look at the systems we provide:"
            />
            <CustomLists
              layout="stacked"
              listStyle="none"
              items={[
                [
                  "Cementitious Waterproofing: Rigid, ideal for internal wet areas.",
                  "Liquid Waterproofing Membrane: Flexible, seamless, and UV/weather resistant.",
                  "Bituminous Waterproofing: Asphalt-based, commonly used on flat roofs.",
                  "EPDM/TPO Membranes: Synthetic rubber, highly durable, UV-resistant.",
                  "Injection Waterproofing: Used to seal leaks by injecting polyurethane or epoxy."
                ]
              ]}
              bullets={[['🧱', '💧', '🛢️', '♻️', '🧪']]}
            />
          </TitleWithContent>
        </motion.div>

        <motion.div {...fadeInUp}>
          <TitleWithContent title="Roof Waterproofing Methodology">
            <ListWithDescription
              titleListType="decimal"
              layout="stacked"
              items={[
                {
                  title: "Surface Preparation",
                  content: [
                    "Clean the surface to remove dust, oil, or debris.",
                    "Repair cracks or holes, allowing them to cure."
                  ]
                },
                {
                  title: "Priming (If Required)",
                  content: [
                    "Apply a compatible primer to enhance adhesion.",
                    "Allow the primer to dry as per instructions."
                  ]
                },
                {
                  title: "Detailing",
                  content: [
                    "Apply reinforcing fabric at joints and protrusions.",
                    "Ensure all critical points are sealed."
                  ]
                },
                {
                  title: "Application of Waterproofing Membrane",
                  content: [
                    "Apply liquid membrane evenly using a roller, brush, or spray.",
                    "Maintain uniform thickness and avoid air bubbles."
                  ]
                },
                {
                  title: "Curing",
                  content: [
                    "Allow the first coat to cure before applying the second.",
                    "Ensure full curing for optimal performance."
                  ]
                },
                {
                  title: "Final Inspection",
                  content: [
                    "Inspect for missed areas or inconsistencies.",
                    "Perform a water test or moisture check if necessary."
                  ]
                }
              ]}
            />
            <Paragraph content="Following the proper steps ensures durability and the effectiveness of the waterproofing system." />
          </TitleWithContent>
        </motion.div>

        <motion.div {...fadeInUp}>
          <TitleWithContent title="Why Choose Us for Roof Waterproofing">
            <Paragraph
              content="At Sheel Waterproofing, we combine experience, certified materials, and expert application to provide reliable and long-lasting roof waterproofing solutions. Here's why our clients trust us:"
            />
            <CustomLists
              listStyle="none"
              layout="stacked"
              items={[
                [
                  "Experienced Professionals: Skilled team for proper assessment and execution.",
                  "Premium Materials: We use only the best waterproofing systems.",
                  "Timely Execution: We complete projects on schedule with minimal disruption.",
                  "Warranty-Backed: Our services come with long-term protection."
                ]
              ]}
              bullets={[["🔧", "🧪", "⏱️", "🛡️"]]}
            />
            <Paragraph
              content="Whether for residential, commercial, or industrial roofing, our tailored waterproofing solutions guarantee lasting protection."
            />
          </TitleWithContent>
        </motion.div>
        
      </div>
    </>
  );
}

export default RoofWaterproofing;
